import { Select } from "antd";
import Search from "antd/es/input/Search";
import React, { FC } from "react";
import { paymentMethodOptions } from "tm-shared/constants";
import { PaymentForm, Product } from "tm-shared/types";

import DropdownFilters from "../FastFilters";
import {
    InputWrapper,
    StyledContainer,
    StyledTopContainer,
} from "./SaleFiltersPanel.styled";

interface SaleFiltersPanelProps {
    query: string;
    onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;

    selectedForm: PaymentForm | null;
    onFormChange: (value: PaymentForm) => void;

    products: { [barcode: string]: Product };
}

export const SaleFiltersPanel: FC<SaleFiltersPanelProps> = ({
    query,
    onSearch,
    selectedForm,
    onFormChange,
    products,
}) => {
    return (
        <StyledContainer>
            <StyledTopContainer>
                <InputWrapper>
                    <Search
                        placeholder="Пошук"
                        defaultValue={query}
                        onChange={onSearch}
                        allowClear
                        size="large"
                    />
                </InputWrapper>

                <Select
                    options={paymentMethodOptions}
                    value={selectedForm}
                    onChange={onFormChange}
                    placeholder="Форма"
                    size="large"
                />
            </StyledTopContainer>

            <DropdownFilters products={products} />
        </StyledContainer>
    );
};
